// فروش eSIM تا تأیید نهایی مخفی است (منو، دکمه داشبورد و مسیرها)؛ برای فعال شدن true شود
export const SHOW_ESIM = true;

export const _adr = {
	Root: process.env.REACT_APP_ROOT,
	Home: "/dashboard",
	Login: {
		Index: "/login",
		ForgetPassword: "/forgetPassword",
		OtpConfirm: "/otp",
		ResetPassword: "/resetPassword",
	},
	SimCardPurchase: {
		Index: "/sp",
		Kit: "/kit",
		Msisdn: "/msisdn",
		Profile: "/profile",
		PreFactor: "/preFactor",
		Document: "/document",
		Final: "/final",
		pending: "/pending",
		// فروش eSIM: شماره و اطلاعات هویتی همان صفحه‌های فیزیکی هستند (با isEsim در state)
		Esim: {
			Bundle: "/esim/bundle",
			PreFactor: "/esim/preFactor",
			Document: "/esim/document",
			Final: "/esim/final",
		},
		foreigners: "/foreigners",
		foreignersChild: {
			Kit: "/kit",
			Msisdn: "/msisdn",
			Authentication: "/Authentication",
			Profile: "/profile",
			PreFactor: "/preFactor",
			Document: "/document",
			Final: "/final",
		},
		Pending: {
			Index: "/pending",
			List: "/list",
			upload: "/upload",
		},
		Report: {
			Index: "/index",
			List: "/list",
		},
	},
	SimCardReplacement: {
		Index: "/simcardreplacement",
		Replacement: "/replacement",
		ValidMsisdn: "/msisdn",
		ValidKit: "/kit",
		PreFactor: "/Prefactor",
		Document: "/document",
		Final: "/final",
		Report: {
			Index: "/report",
			List: "/list",
		},
		Pending: {
			Index: "/pending",
			List: "/list",
			upload: "/upload",
		},
	},
	Accounts: {
		Index: "/Acounts",
		ViewProfile: "/viewprofile",
		ChangePassword: "/changepassword",
		AccountInfo: "/accountinfo",
		AccountList: "/accountlist",
	},
	DCPurchase: {
		Index: "/dc",
		Shop: "/shop",
		Charge: "/charge",
		Prefactor: "/prefactor",
		Final: "/final",
		Report: {
			Index: "/report",
			List: "/list",
		},
	},
	EPPurchase: {
		Index: "/ep",
		Shop: "/shop",
		Valid: "/valid",
		PreFactor: "/prefactor",
		Final: "/final",
		Report: {
			Index: "/report",
			List: "/list",
		},
	},
	DeliveryArea: {
		Index: "/deliveryarea",
		Delivery: {
			Index: "/delivery",
			Valid: "/valid",
			Kit: "/kit",
			Prefactor: "/prefactor",
			Document: "/document",
			Final: "/final",
		},
		Pending: {
			Index: "/pending",
			List: "/list",
			upload: "/upload",
		},
	},
	ChangeOwnerShip: {
		Index: "/changeownership",
		OwnerShip: {
			Index: "/ownership",
			InformationSeller: "/information-seller",
			Profile: "/profile",
			SwapDocument: "/swap-document",
			Prefactor: "/prefactor",
			Document: "/document",
			Final: "/final",
		},
		Report: {
			Index: "/report",
			List: "/list",
		},
		Pending: {
			Index: "/pending",
			List: "/list",
			upload: "/upload",
		},
	},
	Wallet: {
		Index: "/wallet",
		WalletList: "/list",
		Withdraw: {
			Index: "/Withdraw",
			Change: "/change",
			Final: "/final",
		},
	},
	Notification: {
		Index: "/notification",
	},
	CartablePost: {
		Index: "/cartablepost",
	},
	Services360: {
		Index: "/360",
		List: "/list",
		DetailService: "/purchase",
	},
	Corporate: {
		Index: "/corporate",
		Search: "/search",
		UpdateNetwork: "/updateNetwork",
		Action: "/action",
		SimSwap: {
			Index: "/SimSwap",
			ValidMsisdn: "/msisdn",
			ValidKit: "/kit",
			PreFactor: "/Prefactor",
			Final: "/final",
		},
		Ownership: {
			Index: "/Ownership",
			Profile: "/Profile",
			Upload: "/upload-document",
			Review: "/review",
			Final: "/final",
		},
		ChangeStatusSim: "/change-status-sim",
	},
	CreditCard: {
		Index: "/creditcard",
		List: "/list",
		Edit: "/Edit",
		Profile: "/profile",
		Document: "/document",
		Card: "/cardinfo",
		Review: "/review",
		Final: "/final",
	},
	PayBill: {
		Index: "/PayBill",
		Shop: "/shop",
		Bill: "/Bill",
		Prefactor: "/prefactor",
		Final: "/final",
		Report: {
			Index: "/report",
			List: "/list",
		},
	},
	Bulks: {
		Index: "/bulk",
		DCBulk: "/dc",
	},
	LoginAs: {
		Index: "/loginas",
		Logs: "/logs",
	},
	SimLocked: {
		Dealer: {
			Index: "/dealer",
			NewRequest: "/new-request",
			Inventory: "/inventory",
			AssignKit: "/assign-kit",
			AssignKitDetail: "/assign-kit-detail",
			AssignedKitList: "/assigned-kit-list",
			DistributorInventory: "/distributor-inventory",
		},
	},
};
export const _ckey = {
	expiretimeLogin: "_expiretimelogin",
	token: "_authro",
	otpToken: "_authro_otp",
	otpExpireTime: "_expiretime_otp",
	hashPassword: "_hashPassword",
	expireUTCTime: "_expireUTCTime",
};
